import TOF from "../../components/TermOfService";

const TemrsOfService = () => {
  return <TOF />;
};

export default TemrsOfService;
